<div #feedback id="feedback-section">

  @for (message of messages; track message.key) {
  @switch (message.feedback.status) {
  @case ('success') {
  <div role="alert" class="alert alert-success" style="text-align:left;">
    {{ message.feedback.text }}
    <button class="close" data-dismiss="alert" (click)="dismissAlert($event)"><fa-icon [icon]="icon"></fa-icon></button>
  </div>
  }
  @case ('warning') {
  <div role="alert" class="alert alert-warning" style="text-align:left;">
    {{ message.feedback.text }}
    <button class="close" data-dismiss="alert" (click)="dismissAlert($event)"><fa-icon [icon]="icon"></fa-icon></button>
  </div>
  }
  @case ('error') {
  <div role="alert" class="alert alert-error" style="text-align:left;">
    {{ message.feedback.text }}
    <button class="close" data-dismiss="alert" (click)="dismissAlert($event)"><fa-icon [icon]="icon"></fa-icon></button>
  </div>
  }
  @case ('info') {
  <div role="alert" class="alert alert-info" style="text-align:left;">
    {{ message.feedback.text }}
    <button class="close" data-dismiss="alert" (click)="dismissAlert($event)"><fa-icon [icon]="icon"></fa-icon></button>
  </div>
  }
  @default {
  <div role="alert" class="alert alert-warning" style="text-align:left;">
    {{ message.feedback.text }}
    <button class="close" data-dismiss="alert" (click)="dismissAlert($event)"><fa-icon [icon]="icon"></fa-icon></button>
  </div>
  }
  }
  }
</div>
